import React from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Link } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import { Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import Button from '@mui/material/Button'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import PersonAddIcon from '@mui/icons-material/PersonAdd'

const ForTeacherScreen = () => {
  const useStyles = makeStyles((theme) => ({
    rowContainer: {
      paddingLeft: '1.5em',
      paddingRight: '1.5em',
      [theme.breakpoints.up('sm')]: {
        paddingLeft: '3em',
        paddingRight: '3em',
      },
      [theme.breakpoints.up('md')]: {
        paddingLeft: '5em',
        paddingRight: '5em',
      },
    },
    linkText: {
      textTransform: 'uppercase',
      '&:hover, &:visited, &:active': {
        textTransform: 'uppercase',
        color: 'inherit',
      },
    },
  }))

  const classes = useStyles()

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      className="container"
    >
      <Grid item container alignItems="center">
        <Grid item>
          <Link to="/">
            <ArrowBackIcon fontSize="large" color="primary" />
          </Link>
        </Grid>
        <Grid item>
          <Typography
            variant="body2"
            component={Link}
            to="/"
            style={{
              fontWeight: '600',
              marginLeft: '0.5em',
              textDecoration: 'none',
            }}
            className={classes.linkText}
          >
            Back to homepage
          </Typography>
        </Grid>
      </Grid>

      <Grid
        item
        container
        justifyContent="center"
        alignItems="center"
        spacing={4}
        style={{ margin: 'auto' }}
      >
        <Grid item>
          <Button
            component={Link}
            to="/teachers/login"
            variant="contained"
            color="primary"
            size="large"
            style={{ color: 'white', fontWeight: '600' }}
            disableRipple
          >
            <LockOpenIcon fontSize="medium" />
            &nbsp;Sign in teacher account
          </Button>
        </Grid>
        <Grid item>
          <Button
            component={Link}
            to="/teachers/register-teacher"
            variant="contained"
            color="primary"
            size="large"
            style={{ color: 'white', fontWeight: '600' }}
            disableRipple
          >
            <PersonAddIcon fontSize="medium" />
            &nbsp;Register a teacher account
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ForTeacherScreen
